<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :params="{operationId: operationId}"
                    :route-back="getBackRoute()"
                    :title="$t('Devis') +' ' +$t('de') + ' '+ nameDevis"/>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <b-form v-unsave-detector @submit.stop.prevent="onSubmit">

              <div class="row mt-2">
                <div class="col-md-4">
                  <AutoCompleteObjectField
                    :key="'autocomplete-artisan-' + this.autoCompleteKey"
                    :input-class="'medium-label mb-4'"
                    :input-label="$t('devis.Artisan') + '*'"
                    :items="contacts"
                    :required=true
                    :selectedElement="form.artisan.value"
                    input-id="artisan-input"
                    @elementValueChanged="getSelectedValue">
                  </AutoCompleteObjectField>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.numero.invalidFeedback"
                    :label="$t('devis.Numero')"
                    :state="form.numero.state"
                    class="medium-label mb-4"
                    label-for="numero-input">
                    <b-form-input
                      id="numero-input"
                      v-model="form.numero.value"
                      :state="form.numero.state"
                      maxlength="50"
                      type="text"
                      v-on:change="removeInvalidFeedback('numero'); askConfirm=true; ">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.status.invalidFeedback"
                    :label="$t('devis.Status')"
                    class="medium-label mb-4"
                    label-for="status-input">
                    <b-form-select
                      id="status-input"
                      v-model="form.status.value"
                      :disabled="isStatusLocked"
                      :state="form.status.state"
                      required
                      v-on:change="onStatusChange">
                      <option v-for="option in devisStatusList" :value="option.value">
                        {{ $t(option.text) }}
                      </option>
                    </b-form-select>
                  </b-form-group>
                </div>


                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.prixTTC.invalidFeedback"
                    :label="$t(`devis.Prix${isHT ? 'HT':'TTC'}`) + '*'"
                    :state="form.prixTTC.state"
                    class="medium-label mb-4"
                    label-for="prixTTC-input">
                    <b-form-input
                      id="prixTTC-input"
                      v-model="form.prixTTC.value"
                      v-disable-scroll
                      :state="form.prixTTC.state"
                      min="0"
                      required
                      step="any"
                      type="number"
                      v-on:change="managePrixTTC()">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-4">
                  <b-form-group
                    :invalid-feedback="form.tauxTVA.invalidFeedback"
                    :label="$t('devis.TauxTVA')"
                    class="medium-label mb-4"
                    label-for="tauxTVA-input">
                    <b-form-select
                      id="tauxTVA-input"
                      v-model="form.tauxTVA.value"
                      :state="form.tauxTVA.state">
                      <option v-for="option in tauxTVAList" :value="option.value">
                        {{ $t(option.text) }}
                      </option>
                    </b-form-select>
                  </b-form-group>
                </div>
                <div class="col-md-12"></div>
                <div class="col-md-4">
                  <multi-file-field
                    :label="$t('Documents').toString()"
                    :new-files-list="newDocumentsList"
                    :old-files-list="oldDocumentsList"
                    @addFiles="addDocuments"
                    @removeNewFile="removeNewDocument"
                    @removeOldFile="removeOldDocument"/>
                </div>

              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="bold-text level-two-title my-2 main-red-color d-flex align-items-center">
                    <div class="">
                      {{ $t('SchedulePayment.title', {object: isConstruction ? "travaux" : "honoraires"}) }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isConstruction" class="row">
                <div class="col-md-4">
                  <b-form-group
                    :label="$t('schedulePayment.start.constru')"
                    class="medium-label mb-4"
                    label-for="date-input">
                    <datepicker-input
                      v-if="devis.operationConstruction"
                      id="date-input"
                      v-model="devis.operationConstruction.date"
                      v-on:input="askConfirm=true;">
                    </datepicker-input>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group
                    :label="$t('schedulePayment.end.constru')"
                    class="medium-label mb-4"
                    label-for="dateEnd-input">
                    <datepicker-input
                      v-if="devis.operationConstruction"
                      id="dateEnd-input"
                      v-model="devis.operationConstruction.endDate"
                      v-on:input="askConfirm=true;">
                    </datepicker-input>
                  </b-form-group>
                </div>
              </div>
              <div v-else>
                <div class="col-md-4">
                  <b-form-group
                    :label="$t('schedulePayment.Date')"
                    class="medium-label mb-4"
                    label-for="date-input">
                    <datepicker-input
                      id="date-input"
                      v-model="devis.operationHonoraire.date"
                      v-on:input="askConfirm=true;">
                    </datepicker-input>
                  </b-form-group>
                </div>
              </div>
              <div v-if="needSchedule && form.status.value === 'VALIDATED'" class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="medium-text mb-1">
                    {{ $t('SchedulePayment') }}
                  </div>
                </div>
                <template v-for="(payment, index) in schedule.paiements">
                  <div class="col-md-3">
                    <b-form-group :state="!paymentValidation.invalidPayments.includes(index)">
                      <b-form-input
                        :id="`name-input-${index}`"
                        v-model="payment.name"
                        :class="{'is-invalid': paymentValidation.invalidPayments.includes(index)}"
                        @change="validatePayments"
                        @input="validatePayments">
                      </b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-2">
                    <b-form-group :state="!paymentValidation.invalidPayments.includes(index)"
                                  label-for="datePayment-input">
                      <datepicker-input
                        :id="`datePayment-input-${index}`"
                        v-model="payment.date"
                        :class="{'is-invalid': paymentValidation.invalidPayments.includes(index)}"
                        v-on:input="askConfirm=true">
                      </datepicker-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-2">
                    <b-input-group :state="!paymentValidation.invalidPayments.includes(index)"
                                   label-for="percentage-input">
                      <b-form-input
                        :id="`percentage-input-${index}`"
                        v-model="payment.percentageRounded"
                        v-disable-scroll
                        :class="{'is-invalid': paymentValidation.invalidPayments.includes(index)}"
                        max="100"
                        min="0"
                        step="any"
                        type="number"
                        @change="updatePaymentTTC(index)"
                        @input="updatePaymentTTC(index)">
                      </b-form-input>
                      <b-input-group-append :class="{'is-invalid': paymentValidation.invalidPayments.includes(index)}">
                        %
                      </b-input-group-append>
                    </b-input-group>
                  </div>

                  <div class="col-md-2">
                    <b-input-group :state="!paymentValidation.invalidPayments.includes(index)"
                                   label-for="payment-ttc-input">
                      <b-form-input
                        :id="`payment-ttc-input-${index}`"
                        v-model="payment.amount"
                        v-disable-scroll
                        :class="{'is-invalid': paymentValidation.invalidPayments.includes(index)}"
                        min="0"
                        step="any"
                        type="number"
                        @change="updatePaymentPercentage(index)"
                        @input="updatePaymentPercentage(index)">
                      </b-form-input>
                      <b-input-group-append :class="{'is-invalid': paymentValidation.invalidPayments.includes(index)}">
                        {{ isHT ? "€ (HT)" : "€ (TTC)"}}
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                  <div class="col-1 bold-text level-two-title main-red-color mt-1">
                    <trash-icon v-if="schedule.paiements && schedule.paiements.length > 1" class="cursor-pointer"
                                size="18"
                                @click="removePayment(payment)"/>
                  </div>
                  <div v-if="!!(payment.facture && payment.facture.id)" class="col-2 main-red-color mt-2">
                    {{ $t("Facture déjà associée") }}
                  </div>
                </template>
                <div v-show="paymentValidation.isTotalPrixTTCValid < 0" class="main-red-color col-md-4 mb-2 offset-5">
                  {{ $t('Le montant total est supérieur au montant du devis : ') }}
                  {{ -(paymentValidation.isTotalPrixTTCValid) }}€
                </div>
                <div v-show="paymentValidation.isTotalPrixTTCValid > 0" class="main-red-color col-md-4 mb-2 offset-5">
                  {{ $t('Le montant total est inférieur au montant du devis : ') }}
                  {{ paymentValidation.isTotalPrixTTCValid }}€
                </div>
                <div class="col-12">
                  <span class="bold-text addLink" @click="addPayment">+ {{ $t('Add') }}</span>
                </div>
                <div v-if="scheduleInfoMessage" class="col-12 mt-2 info-text">
                  {{ scheduleInfoMessage }}
                </div>
              </div>


              <div class="d-flex justify-content-end">
                <b-button id="validate-btn" type="submit" variant="primary">{{ $t('Validate') }}</b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </b-container>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import AutoCompleteObjectField from "../../components/b122/editFields/AutoCompleteObjectField.vue";
import MultiFileField from "../../components/b122/editFields/MultiFileField";
import DatepickerInput from "../../components/b122/editFields/DatepickerInput.vue";

export default {

  name: 'OperationDevisEdit',

  components: {
    AutoCompleteObjectField,
    BackArrow,
    MultiFileField,
    DatepickerInput
  },

  data() {
    return {
      operationDevisId: this.$route.params.operationDevisId,
      operationId: null,
      isHT: false,
      devis: {},
      title: "",
      contacts: [],
      tauxTVAList: [],
      devisStatusList: [],
      documents: [],
      schedule: {},
      newDocumentsList: [],
      oldDocumentsList: [],
      askConfirm: false,
      needSchedule: false,
      autoCompleteKey: 0,
      isConstruction: true,
      paymentValidation: {
        totalPercentage: 100,
        invalidPayments: [],
        isTotalPrixTTCValid: 0,
      },
      scheduleInfoMessage: null,
      form: {
        artisan:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        numero:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        prixTTC:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        tauxTVA:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        status:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      }
    }
  },

  mounted() {
    this.fetchData()
  },

  computed: {
    isStatusLocked() {
      if (this.schedule.paiements) {
        return this.schedule.paiements.some(payment => payment.facture);
      }

      return false
    },
    nameDevis() {
      if (this.devis.operationConstruction && this.devis.operationConstruction.id) {
        return this.devis.operationConstruction.name || 'N/A';
      } else if (this.devis.operationHonoraire && this.devis.operationHonoraire.id) {
        return this.devis.operationHonoraire.type || 'N/A';
      } else {
        return 'N/A';
      }
    }
  },

  methods: {
    getBackRoute() {
      const from = this.$route.query.from
      if (from === 'OperationDevisFacturesIndex' || from === 'OperationDevisFactureShow') {
        return 'OperationDevisFacturesIndex'
      } else if (from === 'OperationConstructionComponent' || from === 'OperationHonoraireComponent') {
        return null
      }
      return 'OperationDevisIndex'
    },

    async checkForValidatedDevis() {
      let data = new FormData();
      data.append('devisId', this.operationDevisId);

      const response = await api({
        method: 'POST',
        url: '/operationDevis/checkValidatedDevis',
        data: data
      });
      return response.data.exists;
    },


    managePrixTTC() {
      this.removeInvalidFeedback('prixTTC');
      this.askConfirm = true;

      function toNumber(v) {
        if (typeof v === 'string') {
          return parseFloat(v.replace(',', '.')) || 0;
        }
        return Number(v) || 0;
      }

      let prixTTC = toNumber(this.form && this.form.prixTTC ? this.form.prixTTC.value : 0);
      console.log("prixTTC", prixTTC)
      let paiements = (this.schedule && this.schedule.paiements) ? this.schedule.paiements : [];


      if (prixTTC > 0 && paiements.length > 0) {
        paiements.forEach(function (p) {
          p.amount = this.roundToTwo((p.percentage / 100) * prixTTC);
        }, this);
      }
      this.validatePayments();
    },


    async fetchData() {
      await this.getContacts()
      await this.getTauxTVA()
      await this.getDevisStatus()
      if (this.operationDevisId) {
        await this.fetchDevis()
      }
    },

    async getOperation() {
      if (this.operationId != null) {
        await api
          .get(`/operation/${this.operationId}`)
          .then(response => {
            this.isHT = response.data.isHT
          })
      }
    },

    async getTauxTVA() {
      await api
        .get(`/operation/getTauxTVA`)
        .then(response => {
          this.tauxTVAList = response.data
        })
    },

    async getDevisStatus() {
      await api
        .get(`/operationDevis/getStatusDevis`)
        .then(response => {
          this.devisStatusList = response.data
        })
    },

    async getContacts() {
      await api
        .get(`/contact/getContacts`)
        .then(response => {
          this.contacts = response.data
        })
    },

    getSelectedValue(data) {
      this.form.artisan.value = data
    },

    async fetchDevis() {
      await api
        .get(`/operationDevis/${this.operationDevisId}`)
        .then(async response => {
          this.devis = response.data
          this.form.artisan.value = this.devis.artisan
          this.form.numero.value = this.devis.numero
          this.form.tauxTVA.value = this.devis.tauxTVA
          this.form.status.value = this.devis.status.value
          this.oldDocumentsList = this.devis.documents
          this.schedule = this.devis.schedule
          this.needSchedule = !!this.schedule.id
          this.autoCompleteKey += 1
          this.title = this.devis.operationConstruction.name
          this.isConstruction = !!(this.devis.operationConstruction && this.devis.operationConstruction.id)

          if (this.devis.operationConstruction && this.devis.operationConstruction.operation) {
            this.operationId = this.devis.operationConstruction.operation.id
          } else if (this.devis.operationHonoraire && this.devis.operationHonoraire.operation) {
            this.operationId = this.devis.operationHonoraire.operation.id
          }
          if (this.devis.operationId) {
            this.operationId = this.devis.operationId
          }

          if (this.operationId) {
            await this.getOperation()
          }
          if(this.isHT){
            this.form.prixTTC.value = this.devis.prixHT
          } else {
            this.form.prixTTC.value = this.devis.prixTTC
          }

          if (this.schedule.paiements && this.schedule.paiements.length > 0) {
            let usedPercentage = 0;
            this.schedule.paiements.forEach(payment => {
              payment.amount = payment.amount ? payment.amount : 0;
              if (this.form.prixTTC.value) {
                payment.percentageRounded = this.roundToTwo((payment.amount / this.form.prixTTC.value) * 100);
                payment.percentage = (payment.amount / this.form.prixTTC.value) * 100;
              }
              usedPercentage += payment.percentageRounded;
            });


            const remainingPercentage = 100 - usedPercentage;

            let lastPayment = this.schedule.paiements[this.schedule.paiements.length - 1];
            lastPayment.percentageRounded = this.roundToTwo(lastPayment.percentageRounded + remainingPercentage);
          }

        })
        .catch((error) => {
          this.$router.push({
            name: 'OperationShow',
            params: {
              operationId: this.operationId,
              currentSection: 2,
              currentMode: 'devis',
              message: error.response.data.message
            }
          })
        })
    },

    async onStatusChange() {
      if (this.form.status.value === 'VALIDATED') {
        const hasValidatedDevis = await this.checkForValidatedDevis();
        if (hasValidatedDevis) {
          this.form.status.state = false;
          this.form.status.invalidFeedback = this.$t(`Un autre devis est déjà validé pour cette ${this.isConstruction ? 'construction' : 'honoraire'}`);
        } else {
          this.needSchedule = true;
        }
      } else {
        this.form.status.state = null;
        this.form.status.invalidFeedback = null
      }
    },


    async onSubmit() {

      if (this.form.status.value === 'VALIDATED') {
        const hasValidatedDevis = await this.checkForValidatedDevis();
        if (hasValidatedDevis) {
          this.form.status.state = false;
          this.form.status.invalidFeedback = this.$t(`Un autre devis est déjà validé pour cette ${this.isConstruction ? 'construction' : 'honoraire'}`);
          return;
        }
      }
      const isFormInvalid = Object.values(this.form).some(field => field.state === false);
      this.validatePayments()
      if (isFormInvalid || (this.form.status.value === 'VALIDATED' && this.paymentValidation.isTotalPrixTTCValid != 0)) {
        return;
      }

      let prixTTCToSend = this.form.prixTTC.value;
      if (this.isHT && this.form.tauxTVA.value) {
        const taux = parseFloat(this.form.tauxTVA.value.replace('%', '')) / 100;
        prixTTCToSend = this.roundToTwo(this.form.prixTTC.value * (1 + taux));
      }

      let scheduleToSend = this.schedule;
      if (this.isHT && this.form.tauxTVA.value && scheduleToSend && scheduleToSend.paiements) {
        const taux = parseFloat(this.form.tauxTVA.value.replace('%', '')) / 100;
        scheduleToSend = {
          ...this.schedule,
          paiements: this.schedule.paiements.map(p => ({
            ...p,
            amount: this.roundToTwo((parseFloat(p.amount) || 0) * (1 + taux))
          }))
        };
      }


      let data = new FormData();
      data.append('numero', this.form.numero.value);
      data.append('artisan', JSON.stringify(this.form.artisan.value));
      data.append('prixTTC', prixTTCToSend);
      data.append('tauxTVA', this.form.tauxTVA.value);
      data.append('status', this.form.status.value);
      data.append('isConstruction', this.isConstruction);
      if (this.isConstruction) {
        data.append('dateConstruction', this.devis.operationConstruction.date);
        data.append('endDateConstruction', this.devis.operationConstruction.endDate);
      } else {
        data.append('dateHonoraire', this.devis.operationHonoraire.date);
      }
      if (this.needSchedule && this.form.status.value === 'VALIDATED') {
        data.append('schedule', JSON.stringify(scheduleToSend));
      }
      if (this.newDocumentsList && this.newDocumentsList.length > 0) {
        data.append('nbFile', this.newDocumentsList.length);
      } else {
        data.append('nbFile', 0);
      }
      this.newDocumentsList.forEach((file, index) => {
        data.append(`file[${index}]`, file);
      });

      api({
        method: 'PUT',
        url: `/operationDevis/${this.operationDevisId}`,
        data: data
      })
        .then(async response => {
          await this.generateMonthlyCharges()

          const from = this.$route.query.from

          if (from === 'OperationConstructionComponent' || from === 'OperationHonoraireComponent') {
            this.successToast(this.$i18n.t('Devis') + ' "' + this.form.numero.value + '" ' + this.$i18n.t('modified'));
            this.$router.go(-1)
            return
          }

          let targetRoute = 'OperationDevisIndex'
          let targetParams = {}

          if (from === 'OperationDevisFacturesIndex' || from === 'OperationDevisFactureShow') {
            targetRoute = 'OperationDevisFacturesIndex'
            targetParams = {operationId: this.operationId}
          }

          this.$router.push({
            name: targetRoute,
            params: targetParams
          }, () => {
            this.$nextTick(() => {
              this.successToast(this.$i18n.t('Devis') + ' "' + this.form.numero.value + '" ' + this.$i18n.t('modified'));
            });
          });
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {

            const from = this.$route.query.from

            if (from === 'OperationConstructionComponent' || from === 'OperationHonoraireComponent') {
              this.$router.go(-1)
              return
            }

            let targetRoute = 'OperationShow'
            let targetParams = {
              message: error.response.data.message,
              operationId: this.operationId,
              currentSection: 2,
              currentMode: 'devis'
            }

            if (from === 'OperationDevisFacturesIndex' || from === 'OperationDevisFactureShow') {
              targetRoute = 'OperationDevisFacturesIndex'
              targetParams = {
                operationId: this.operationId,
                message: error.response.data.message
              }
            }

            this.$router.push({
              name: targetRoute,
              params: targetParams
            });
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField;
            this.form[invalidField]['state'] = false;
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message);
          }
        });
    },

    async generateMonthlyCharges() {

      let data = new FormData()
      data.append('operationId', this.operationId)

      api({
        method: 'POST',
        url: '/treasury/generateMonthlyCharges',
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 2,
                message: error.response.data.message
              }
            })
          }
        })
    },

    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
    },

    successToast(operationName) {
      this.$bvToast.toast(operationName, {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    },

    addDocuments(files) {
      files.forEach(file => {
        if (file) {
          this.newDocumentsList.push(file)
        }
      })
    },

    removeNewDocument(file) {
      this.newDocumentsList.splice(this.newDocumentsList.indexOf(file), 1)
    },

    removeOldDocument(file) {
      this.oldDocumentsList.splice(this.oldDocumentsList.indexOf(file), 1)
      this.documents.splice(this.documents.indexOf(file), 1)
      this.newDocumentsList.splice(this.newDocumentsList.indexOf(file), 1)
      if (file.id) {
        api.delete(`/operationDevis/deleteFileDevis/${file.id}`)
      }
    },

    removePayment(paymentToRemove) {
      if (paymentToRemove.facture) {
        this.$confirm(this.$i18n.t('Confirm.delete.paiement.with.facture').toString()).then(() => {
          this.schedule.paiements = this.schedule.paiements.filter(payment => payment !== paymentToRemove);
          this.validatePayments()
        })
      } else {
        this.schedule.paiements = this.schedule.paiements.filter(payment => payment !== paymentToRemove);
        this.validatePayments()
      }
    },

    addPayment() {
      this.validatePayments();
      if (this.paymentValidation.isTotalPrixTTCValid > 0) {
        const newPayment = {
          id: null,
          name: '',
          date: null,
          percentage: 0,
          percentageRounded: 0,
          amount: 0,
        };

        if (!this.schedule.paiements) {
          this.$set(this.schedule, 'paiements', []);
        }

        this.schedule.paiements.push(newPayment);
      } else {
        this.scheduleInfoMessage = this.$i18n.t('Montant total du devis déjà atteint').toString()
        setTimeout(() => {
          this.scheduleInfoMessage = null
        }, 3000)
      }

    },


    updatePaymentTTC(index) {
      const payment = this.schedule.paiements[index];
      payment.percentage = payment.percentageRounded || 0;
      if (payment.percentage && this.form.prixTTC.value) {
        payment.amount = this.roundToTwo((payment.percentage / 100) * this.form.prixTTC.value);
      }

      this.validatePayments()
    },

    updatePaymentPercentage(index) {
      const payment = this.schedule.paiements[index];
      payment.amount = payment.amount || 0;
      if (payment.amount && this.form.prixTTC.value) {
        payment.percentage = (payment.amount / this.form.prixTTC.value) * 100;
        payment.percentageRounded = this.roundToTwo((payment.amount / this.form.prixTTC.value) * 100);
      }

      this.validatePayments()
    },

    recalculatePayments(changedIndex) {
      const totalAmount = parseFloat(this.form.prixTTC.value) || 0;
      this.schedule.paiements.forEach((payment, index) => {
        payment.percentage = parseFloat(payment.percentage) || 0;
        payment.amount = parseFloat(payment.amount) || 0;
      });

      let usedPercentage = 0;
      let usedAmount = 0;

      for (let i = 0; i <= changedIndex; i++) {
        usedPercentage += this.schedule.paiements[i].percentage;
        usedAmount += this.schedule.paiements[i].amount;
      }

      const remainingPercentage = 100 - usedPercentage;
      const remainingAmount = totalAmount - usedAmount;

      const paymentsBelow = this.schedule.paiements.slice(changedIndex + 1);
      if (paymentsBelow.length > 0) {
        const totalBelowPercentage = paymentsBelow.reduce((sum, payment) => sum + payment.percentage, 0);
        paymentsBelow.forEach((payment, index) => {
          if (index < paymentsBelow.length - 1) {
            payment.percentage = totalBelowPercentage > 0 ? (payment.percentage / totalBelowPercentage) * remainingPercentage : 0;
            payment.amount = this.roundToTwo((payment.percentage / 100) * totalAmount);
          }
        });

        let lastPayment = paymentsBelow[paymentsBelow.length - 1];
        let calculatedLastPercentage = remainingPercentage - paymentsBelow.slice(0, -1).reduce((sum, p) => sum + p.percentage, 0);
        let calculatedLastAmount = remainingAmount - paymentsBelow.slice(0, -1).reduce((sum, p) => sum + p.amount, 0);

        lastPayment.percentage = calculatedLastPercentage < 0 ? 0 : calculatedLastPercentage;
        lastPayment.amount = calculatedLastAmount < 0 ? 0 : calculatedLastAmount;

        this.$forceUpdate()

      }

      this.validatePayments();
    },


    validatePayments() {
      let totalAmount = this.schedule.paiements.reduce((total, payment) => total + (parseFloat(payment.amount) || 0), 0);
      let formPrixTTCValue = parseFloat(this.form.prixTTC.value) || 0;

      this.paymentValidation.isTotalPrixTTCValid = (formPrixTTCValue - totalAmount).toFixed(2);
      this.$forceUpdate();

      return this.paymentValidation.isTotalPrixTTCValid;
    },

    roundToTwo(num) {
      return +(Math.round(num + "e+2") + "e-2");
    },

  }
}
</script>

<style scoped>

.info-text {
  color: #07153C !important;
  font-style: italic;
}

</style>



// WEBPACK FOOTER //
// src/views/operationDevis/OperationDevisEdit.vue